export interface BlockIds {
  take(preferred: unknown): string;
}

export function createBlockIds(): BlockIds {
  const used = new Set<string>();
  let counter = 0;
  return {
    take(preferred: unknown): string {
      if (typeof preferred === 'string' && preferred.length > 0 && !used.has(preferred)) {
        used.add(preferred);
        return preferred;
      }
      let id: string;
      do {
        counter += 1;
        id = `rb${counter}`;
      } while (used.has(id));
      used.add(id);
      return id;
    },
  };
}
